import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { observer } from 'mobx-react'
import { action, observable, toJS } from 'mobx'
import { Button, Row, Col, Dropdown, Modal } from 'react-bootstrap'
// import { LinkWithLocale } from 'src/views/components'
import { i18nTranslate } from 'src/utils'
import { SHIPPING_TYPE } from 'src/utils/constant'
// import { pageNames } from 'src/routes/pathParams'
import {
  addressContainer,
  customerContainer,
  subscriptionContainer,
  cartContainer,
  checkoutContainer,
} from 'src/models'
import {
  application,
  capitalizeFirstLetter,
  getConvertedMonth,
  getConvertedYear,
  getTotalPagesForPagination,
  isGPSEnabled,
} from 'src/utils'
import { getAppConfig } from 'config/appConfig'
import {
  toastState,
  Icons,
  AccordionBlock,
  overlayState,
  // ConfirmationModal,
} from 'src/views/components'
import { ShippingEditingModal } from './ShippingEditingModal'
import EditUpdatePaymentModal from '../Payments/EditUpdatePaymentModal'
import PaymentIcon from 'src/views/components/PaymentIcon'
// import { isSubscriptionEditable } from './deps'
import { Link } from 'react-router-dom'
import isArray from 'lodash/isArray'
import { dateFormatDeps } from 'src/deps'
import { CreditCardExpiryInfo } from './CreditCardExpiryInfo'
import dayjs from 'dayjs'
import './styles.scss'

@observer
class SubscriptionShippingDetailsView extends React.Component {
  @observable isEditShippingAddress = false
  @observable isEditPayments = false
  @observable isEditShippingMethod = false
  @observable disablePaymentEdit = false
  @observable disableShippingEdit = false
  @observable enablePaymentModal = false
  @observable isPaymentCallInProgress = false
  @observable isShippingAddressCallInProgress = false
  @observable isShippingMethodCallInProgress = false
  @observable isAddressEditModal = false
  @observable editSubscriptionAddress = {}
  @observable showEditSubscriptionModal = false
  @observable IDofCardToBeEdited = ''
  @observable selectedCardData = {}
  @observable showEditPaymentModal = false
  @observable showDeleteConfirmationModal = false
  isCardExpiringSoon = false
  isCardExpired = false
  subscriptionPaymentId = ''
  subscriptionShippingAddressId = ''
  selectedShippingAddressId = ''
  newAddressToUpdate = ''
  subscriptionShipping = ''
  selectedDefaultCardId = ''
  totalPagesLength = 0
  currentPageDetails = {}

  // Action to toogle Update Card modal
  @action
  toggleEditSubscriptionValue = (e, id = 0) => {
    this.showEditSubscriptionModal = !this.showEditSubscriptionModal
    this.IDofCardToBeEdited = id
  }

  constructor(props) {
    super(props)
    this.shippingEditingModalRef = React.createRef()
  }

  async componentDidMount() {
    const token = this.props.location?.queryParams?.token || ''
    if (!token) {
      addressContainer.getProfileAddress()
      // customerContainer.getPayment()
      await customerContainer.getPaymentsForDashboard()
      // https://jira.skava.com/browse/YLUS-4471
    }
    // if (this.props.isRegisteredUser) {
    // }
    subscriptionContainer.ccExpiryFlag =
      this.isCardExpiringSoon || this.isCardExpired
    subscriptionContainer.ccCardExpired = this.isCardExpired
  }

  componentDidUpdate(prevProps) {
    this.disableShippingDetails()
    subscriptionContainer.ccExpiryFlag =
      this.isCardExpiringSoon || this.isCardExpired
    subscriptionContainer.ccCardExpired = this.isCardExpired

    const { pageableInfo = {} } = customerContainer.paymentsForDashboard || {}
    const { page = 1, count = 1 } = pageableInfo || {}
    this.currentPageDetails = {
      page: count == 1 ? page - 1 : page,
      isFromSubscription: true,
    }
    this.totalPagesLength = getTotalPagesForPagination(pageableInfo)
  }

  /**
   * Toggles the delete confirmation modal.
   * @async
   * @function
   * @param {string} [id=''] - The ID of the card.
   * @returns {Promise<void>} A Promise that resolves when the modal is toggled.
   */
  toggleDeleteConfirmationModal = async (id = '') => {
    const { pageableInfo = {} } = customerContainer.paymentsForDashboard || {}
    this.selectedCardData = await this.getCardData(id, pageableInfo?.page)
    this.showDeleteConfirmationModal = !this.showDeleteConfirmationModal
  }

  /**
   * Toggles the edit/update payment modal.
   * @async
   * @function
   * @param {string} [id=''] - The ID of the card.
   * @returns {Promise<void>} A Promise that resolves when the modal is toggled.
   */
  toggleEditPaymentModal = async (id = '') => {
    const { pageableInfo = {} } = customerContainer.paymentsForDashboard || {}
    if (!this.showEditPaymentModal && id != '') {
      this.selectedCardData = await this.getCardData(id, pageableInfo?.page)
    }

    this.IDofCardToBeEdited = id?.toString()
    this.showEditPaymentModal = !this.showEditPaymentModal
  }

  /**
   * Fetches card data from ID.
   * @date 10/11/2023 - 10:01:35 PM
   *
   * @async
   * @param {string} [id='']
   * @returns {object}
   */
  getCardData = async (id = '', activePage = 1) => {
    const response = await customerContainer?.getPaymentsForDashboard(
      false,
      activePage
    )

    const transformedResponse = customerContainer.transformPaymentResponse(
      response,
      activePage
    )
    return transformedResponse?.payments?.find(
      item => item?.id === id?.toString()
    )
  }

  /**
   * Deletes the payment and refresh the data.
   * @date 10/11/2023 - 9:59:54 PM
   *
   * @async
   * @returns {*}
   */
  handleDeletePayment = async () => {
    let selectedCardDetails = {
      ...this.selectedCardData,
      ...this.currentPageDetails,
    }
    await customerContainer.deletePayment(selectedCardDetails)
    this.toggleDeleteConfirmationModal()
    const month = this.props?.location?.queryParams?.month || ''
    await subscriptionContainer?.getAllSubscriptionsPreference(
      customerContainer?.userId,
      month === 'showall' ? '' : month,
      month === 'showall' ? true : false
    )
  }

  /**
   * Handler method for Delete card link click.
   * @date 10/11/2023 - 10:04:44 PM
   *
   * @param {object} cardData
   * @returns {JSX.Element}
   */
  handleDeletePaymentMethod = cardData => {
    const cardNumber = cardData?.accountInfo?.cardNumber || ''
    const cardProvider = cardData?.accountInfo?.provider || ''

    return (
      <div>
        <div className="delete-msg-wrapper">
          <span>
            {i18nTranslate('payment.deleteMessageStart', 'Delete')}&nbsp;
          </span>
          <span>{capitalizeFirstLetter(cardProvider)} &nbsp;</span>
          <span>****{cardNumber}&nbsp;</span>
          <span>
            {i18nTranslate(
              'payment.deleteMessageEnd',
              'from your saved payments?'
            )}
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-outline-primary cancel-btn"
            onKeyPress={this.toggleDeleteConfirmationModal}
            onClick={this.toggleDeleteConfirmationModal}>
            {i18nTranslate('payment.cancelDelete', 'Cancel')}
          </button>
          <button
            className="btn btn-primary confirm-btn"
            onKeyPress={() => {
              this.handleDeletePayment()
            }}
            onClick={() => {
              this.handleDeletePayment()
            }}>
            {i18nTranslate('payment.confirmDelete', 'Confirm')}
          </button>
        </div>
      </div>
    )
  }

  disableShippingDetails = () => {
    const subscriptionProducts =
      subscriptionContainer.showAllSubscriptionResponse

    const {
      // freezeOrderDate,
      // orderProcessingDate,
      lastOrderProcessingDate,
      // currentDate = '',
      currentDateInMillis = '',
      // startMonth,
      lastOrderStatus = '',
    } = subscriptionContainer.subscriptionPreferenceResponse
    // const selectedMonth1 =
    //   subscriptionContainer.subscriptionPreferenceResponse?.selectedMonth || ''
    // const selectedMonth2 =
    //   subscriptionContainer.subscriptionPreferenceResponse?.selectedSubscriptions?.[0]?.selectedMonth
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    // let selectedMonth = selectedMonth1 || selectedMonth2
    // selectedMonth = selectedMonth - 1

    // if (
    //   isTodayIsCurrentProcessingDay({
    //     freezeOrderDate,
    //     orderProcessingDate,
    //     lastOrderProcessingDate,
    //     currentDate,
    //     selectedMonth,
    //     startMonth,
    //   })
    // ) {
    //   this.disablePaymentEdit = true
    //   this.disableShippingEdit = true
    // }

    // EC-8402 - currentDate format is not supported by Safari 13.1.
    // And so, using the new node 'currentDateInMillis',
    // 'currentDateInMillis' is in timestamp format
    // const dateNow = new Date(parseUTCDate(currentDate || ''))
    // const dateNow = new Date(currentDateInMillis)
    // const todaysDate = dateNow.getDate()
    // const currentMonth = dateNow.getMonth()

    // const lastOrderProcessedMonth = new Date(lastOrderProcessingDate).getMonth()

    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderProcessedMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )
    /* const disableShippingAlone =
      lastOrderProcessedMonth == currentMonth && 
     (lastOrderStatus.toLowerCase() == 'order_failed' ||
        lastOrderStatus.toLowerCase() == 'payment_failed') */

    const disableBothShippingAndPaymentEdit =
      lastOrderProcessedMonth == currentMonth &&
      lastOrderStatus.toLowerCase() == 'order_created'

    /* if (disableShippingAlone) {
      this.disablePaymentEdit = false
      this.disableShippingEdit = true
    } else */ if (disableBothShippingAndPaymentEdit) {
      this.disablePaymentEdit = true
      this.disableShippingEdit = true
    } else {
      this.disablePaymentEdit = false
      this.disableShippingEdit = false
      if (
        subscriptionContainer.showEditPaymentFromModal &&
        subscriptionProducts?.length > 0 &&
        subscriptionProducts?.[0]?.subscriptions?.length > 0
      ) {
        this.enablePaymentModal = true
      } else {
        this.enablePaymentModal = false
        subscriptionContainer.showEditPaymentFromModal = false
      }
    }

    // const enableShippingAndPaymentEdit = isSubscriptionEditable(
    //   currentMonth,
    //   selectedMonth,
    //   lastOrderProcessedMonth
    // )

    // if (enableShippingAndPaymentEdit) {
    //   this.disablePaymentEdit = false
    //   this.disableShippingEdit = false
    //   if (
    //     subscriptionContainer.showEditPaymentFromModal &&
    //     subscriptionProducts &&
    //     subscriptionProducts.length > 0 &&
    //     subscriptionProducts[0].subscriptions.length > 0
    //   ) {
    //     this.enablePaymentModal = true
    //   } else {
    //     this.enablePaymentModal = false
    //     subscriptionContainer.showEditPaymentFromModal = false
    //   }
    // } else {
    //   this.disableShippingEdit = true
    //   this.disablePaymentEdit = true
    // }
  }

  handleSubscriptionAddressEdit = address => {
    const toastMessage = i18nTranslate(
      'subscription.unabletoEditDelete',
      'Address is being used in your subscription order, so you are not allowed to Edit/Delete'
    )

    const isSubscriptionAddress =
      (this.subscriptionShippingAddressId == address?.addressId &&
        address?.properties?.isSubscriptionAddress) ||
      'false' === 'true'

    if (!isSubscriptionAddress) {
      this.editSubscriptionAddress = address
      this.isEditShippingAddress = !this.isEditShippingAddress
      this.isAddressEditModal = true
    } else {
      toastState.setToastMessage(toastMessage)
    }
  }

  renderShippingAddress = (address = {}, isFromModal = false) => {
    const {
      addressLine1 = '',
      addressLine2 = '',
      street1 = '',
      street2 = '',
      city = '',
      state = '',
      zipCode = '',
      zip = '',
      // phone = '',
      country = '',
      properties,
      deliveryInstruction,
      firstName = '',
      lastName = '',
    } = address
    const actualZip = zipCode || zip
    return (
      <>
        <div
          className={` ${isFromModal ? 'd-flex' : 'shipping-section'} ${
            this.isEditShippingAddress ? '' : ' '
          }`}
          data-testid="qa-user-sub-shipping-address">
          {!isFromModal && (
            <Row
              noGutters
              className={
                'align-items-center justify-content-between shipping-title'
              }>
              <div className="shipping-title-inner d-flex justify-content-between">
                <div className="text-uppercase shipping-text heading-6">
                  {i18nTranslate(
                    'subscription.shippingTitle',
                    'Shipping Address'
                  )}
                </div>
                <div className="">
                  {this.disableShippingEdit === false && (
                    <Button
                      disabled={
                        this.disableShippingEdit ||
                        this.isShippingAddressCallInProgress ||
                        this.isShippingMethodCallInProgress
                      }
                      onClick={() => (this.isEditShippingAddress = true)}
                      className={'edit-button shadow-none p-0'}
                      data-testid="qa-user-sub-shipping-address-edit">
                      <Icons
                        name="CRUD"
                        icontype="edit"
                        width="20px"
                        customIcon={
                          i18nTranslate(
                            'subscriptions.editButtonText',
                            'Edit'
                          ) +
                          ' ' +
                          i18nTranslate(
                            'subscription.shippingTitle',
                            'Shipping Address'
                          ).toLowerCase()
                        }
                        alt={i18nTranslate(
                          'subscription.shippingAddressEditIcon',
                          'shipping address edit icon'
                        )}
                        ariaLabel={i18nTranslate(
                          'subscription.shippingAddressEditIcon',
                          'shipping address edit icon'
                        )}
                      />
                    </Button>
                  )}
                </div>
              </div>
            </Row>
          )}
          {!isEmpty(address) ? (
            <p className="subscription-shipping-address paragraph-s pr-4">
              {firstName +
                `${firstName && ' '} ` +
                lastName +
                `${lastName && ','} ` +
                addressLine1 +
                `${addressLine1 && ','} ` +
                addressLine2 +
                `${addressLine2 && ','} ` +
                street1 +
                `${street1 && ','} ` +
                street2 +
                `${street2 && ','} ` +
                city +
                `${city && ','} ` +
                state +
                `${state && ','} ` +
                actualZip}
              <br />
              {country}
              <br />
              {deliveryInstruction && (
                <>
                  {i18nTranslate(
                    'shippingInstructions',
                    'Shipping instructions'
                  )}
                  {`: ${deliveryInstruction}`}
                </>
              )}
              {properties?.deliveryInstruction && (
                <>
                  <p className="shipping-text heading-6 m-0 pt-2">
                    {i18nTranslate(
                      'shippingInstructions',
                      'Shipping instructions'
                    )}
                    :
                  </p>
                  {properties?.deliveryInstruction}
                </>
              )}
              <br />
            </p>
          ) : (
            ''
          )}
          {isFromModal && !addressContainer.isRecommendationsVisible && (
            <p className="custom-alignment">
              <button
                tabIndex={0}
                onClick={() => this.handleSubscriptionAddressEdit(address)}
                className="custom-edit-link-button">
                {i18nTranslate('edit', 'Edit')}
              </button>
            </p>
          )}
        </div>
      </>
    )
  }
  // 'showUpdateCard' is used to show 'Update Card' label for expired cards

  renderPaymentMethod = (
    payment = {},
    isFromModal = false,
    isDefault = false
  ) => {
    const {
      name = '',
      firstName = '',
      lastName = '',
      cardExpirationYear = '',
      cardExpirationMonth = '',
      expiryYear = '',
      expiryMonth = '',
      type = '',
      displayName = '',
      provider = '',
      id = '',
      // properties = {},
    } = payment
    this.selectedDefaultCardId = id || ''
    /*
     * Temporarily splitting card number into 4 per group
     * TODO: Need to split card number based on card type
     */
    const CC_EXPIRY_IN_MONTH = 1
    const cardNumber = (payment?.cardNumber || '').replace(
      /^(.{4})(.{4})(.{4})(.*)$/,
      '$1-$2-$3-$4'
    )
    const defaultSelectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const monthVal = location?.queryParams?.month || ''
    let selectedMonth = 0
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const lastOrderProcessedMonth =
      new Date(lastOrderProcessingDate).getMonth() + 1
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    if (subscriptionContainer.selectedMonth != '') {
      selectedMonth = subscriptionContainer.selectedMonth
    } else {
      selectedMonth = defaultSelectedMonth
    }
    const totalActiveSubscriptionCount =
      cartContainer.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount
    const accountNumber = payment?.properties?.accountNumber || ''
    const bankName = payment?.properties?.bankName || ''
    const endingDigits = accountNumber
      ? accountNumber.substr(accountNumber.length - 4)
      : undefined
    const currentDateTimeStamp = Date.now()
    const { month, year } =
      dateFormatDeps.convertTimeStampToDate(currentDateTimeStamp)
    const expiryText = i18nTranslate('payment.cardExpiresText', 'Expires')
    const expiredText = i18nTranslate(
      'payment.cardExpiredText',
      'Card is Expired'
    )

    const daysInExpirationMonth = dayjs(
      `${parseInt(cardExpirationYear || expiryYear)}-${parseInt(
        cardExpirationMonth || expiryMonth
      )}-01`
    ).daysInMonth()

    const cardExpirationDate = dayjs(
      `${parseInt(cardExpirationYear || expiryYear)}-${parseInt(
        cardExpirationMonth || expiryMonth
      )}-${daysInExpirationMonth}`
    )

    const daysLeftForExpiry = cardExpirationDate.diff(
      dayjs().format('YYYY-MM-DD'),
      'day'
    )

    //show expiring soon message if within 60days
    this.isCardExpiringSoon = daysLeftForExpiry <= 60 && daysLeftForExpiry >= 0

    //show expired message for past days
    this.isCardExpired = daysLeftForExpiry < 0

    /*const isCardExpired =
      year < parseInt(cardExpirationYear || expiryYear)
        ? true
        : year === parseInt(cardExpirationYear || expiryYear)
        ? month <= parseInt(cardExpirationMonth || expiryMonth)
          ? true
          : false
        : false*/
    const expryTxt = this.isCardExpired ? expiryText : expiredText
    const endingText = '**'
    const cardFirstName = firstName || name

    // Check if the card is associated to subscription or not
    if (!isDefault) {
      isDefault = this.checkIsDefaultPayment(payment?.id)
    }

    return (
      <>
        <Col
          className={`p-0 ${isFromModal ? '' : 'shipping-section'}`}
          data-testid="qa-user-sub-payment-method">
          {!isFromModal && (
            <Row
              noGutters
              className={
                'align-items-center justify-content-between shipping-title'
              }>
              {lastOrderProcessedMonth == selectedMonth &&
              (lastSubscriptionOrderStatus.toLowerCase() === 'payment_failed' ||
                lastSubscriptionOrderStatus.toLowerCase() === 'order_failed') &&
              totalActiveSubscriptionCount != 0 &&
              monthVal !== 'showall' ? (
                <div className="col-1 warningIcnDiv">
                  <Icons
                    name="product-icon"
                    icontype="danger-warning"
                    className="subscription-wrn-icon"
                    color="#8C6E43"
                  />
                </div>
              ) : (
                ''
              )}
              <div className="shipping-title-inner d-flex justify-content-between">
                <div className="text-uppercase shipping-text heading-6">
                  {i18nTranslate('subscription.paymentTitle', 'Payment Method')}
                </div>
                <div className="">
                  {this.disablePaymentEdit ? (
                    ''
                  ) : (
                    <Button
                      disabled={
                        this.disablePaymentEdit || this.isPaymentCallInProgress
                      }
                      // onClick={() => {
                      //   type && type.toLowerCase() === 'ach'
                      //     ? toastState.setToastMessage(
                      //         i18nTranslate(
                      //           'paymentCard.ACHPayment Edit',
                      //           'ACH Payment is being used in your subscription order, so you are not allowed to Edit/Delete'
                      //         )
                      //       )
                      //     : (this.isEditPayments = true)
                      // }}
                      onClick={() => (this.isEditPayments = true)}
                      className={'edit-button shadow-none p-0'}
                      data-testid="qa-user-sub-payment-method-edit">
                      <Icons
                        name="CRUD"
                        icontype="edit"
                        customIcon={
                          i18nTranslate(
                            'subscriptions.editButtonText',
                            'Edit'
                          ) +
                          ' ' +
                          i18nTranslate(
                            'subscription.paymentTitle',
                            'Payment Method'
                          ).toLowerCase()
                        }
                        width="20px"
                        alt={i18nTranslate(
                          'subscription.paymentMethodEditIcon',
                          'payment method edit icon'
                        )}
                        ariaLabel={i18nTranslate(
                          'subscription.paymentMethodEditIcon',
                          'payment method edit icon'
                        )}
                      />
                    </Button>
                  )}
                </div>
              </div>
            </Row>
          )}
          {!isEmpty(payment) ? (
            <>
              {type && type.toLowerCase() === 'ach' ? (
                <Col className="p-0 text-dark paragraph-s">
                  {i18nTranslate('subscription.achPayment', 'ACH')}
                  <br />
                  {bankName}
                  <br />
                  {endingDigits && (
                    <>{`${i18nTranslate(
                      'payment.accountEndingText',
                      'Account ending in'
                    )} - ${endingDigits}`}</>
                  )}
                </Col>
              ) : type && type.toLowerCase() === 'paypalsubscription' ? (
                <Col className="p-0 text-dark paragraph-s">
                  {i18nTranslate(
                    'subscription.paypalsubscription',
                    'PayPal Account'
                  )}
                  <br />
                  {displayName}
                </Col>
              ) : (
                type &&
                (type?.toLowerCase() === 'creditcard' ||
                  type?.toLowerCase() === 'debitcard') && (
                  <div className="p-0 text-dark paragraph-s m-0shipping-text ">
                    {name !== null && `${cardFirstName} `}
                    {/*lastName != null && ` ${lastName}` */}
                    {cardFirstName !== lastName &&
                      lastName !== null &&
                      `${lastName} `}
                    {(cardFirstName !== null || lastName !== null) && <br />}
                    {!isFromModal ? (
                      <>
                        {endingText}
                        {cardNumber}
                        <br />
                      </>
                    ) : (
                      <span className="subscription-payment-details">
                        <PaymentIcon type={provider?.toLowerCase()} />
                        <span>{provider}</span>
                        <span>
                          {endingText}
                          {cardNumber}
                        </span>
                      </span>
                    )}

                    {/* 
                <br />
                `${cardExpirationMonth || expiryMonth}/${
                  cardExpirationYear || expiryYear
                }` */}

                    <span
                      data-testid="qa-expirydate"
                      className={`paragraph-m payment-card-expiry ${
                        this.isCardExpired ? 'payment-card-expired' : ''
                      } `}>
                      {/* {this.isCardExpired && (
                    <span className="subscription-card-expired">
                      {i18nTranslate('payment.cardExpiredText', 'Card is expired')}
                      &nbsp;
                    </span>
                  )} */}
                      {`${this.isCardExpired ? expiredText : expiryText} ${
                        cardExpirationMonth || expiryMonth
                      }/${String(cardExpirationYear || expiryYear)?.substr(2)}`}
                    </span>
                    {subscriptionContainer.ccExpiryFlag && (
                      <CreditCardExpiryInfo
                        isCardExpired={this.isCardExpired}
                        isCardExpiringSoon={this.isCardExpiringSoon}
                        cardType={type}
                      />
                    )}
                    {/* Update card label is shown only for sub associated card */}
                    <br />
                    {isFromModal && (
                      <div className="subscription-card-button-wrapper">
                        <div className="subscription-card-button-wrapper">
                          <span>
                            <Button
                              variant="link"
                              className="subscription-card-link-btn p-0"
                              onClick={e => {
                                this.toggleEditPaymentModal(payment?.id)
                              }}
                              cardId={payment?.id}>
                              {this.isCardExpired
                                ? i18nTranslate('catalog.Update', 'Update', {
                                    nameSpace: 'ssr-resource',
                                  })
                                : i18nTranslate('edit', 'Edit')}
                            </Button>
                          </span>
                          <span>
                            <Button
                              variant="link"
                              className="subscription-card-link-btn p-0"
                              onClick={e => {
                                this.toggleDeleteConfirmationModal(payment?.id)
                              }}
                              cardId={payment?.id}>
                              {i18nTranslate('cart.delete', 'Delete')}
                            </Button>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )
              )}
            </>
          ) : (
            ''
          )}
        </Col>
      </>
    )
  }

  // Function to check if card is associated with subscription or not
  checkIsDefaultPayment = (cardId = 0) => {
    return (
      cardId ===
      subscriptionContainer?.subscriptionPreferenceResponse?.payment?.id
    )
  }

  renderShippingMethod = (shippingMethod = {}, isFromModal = false) => {
    const {
      // deliveryPeriod = '',
      // instruction = '',
      method = '',
      // type = '',
      name = '',
      // expectedDaysForDelivery = '',
      cost = '0',
      //properties,
    } = shippingMethod
    let shippingMethodAvailable = false
    const month = this.props.location?.queryParams?.month || ''
    if (subscriptionContainer.subscriptionPreferenceResponse?.shippingMethods) {
      shippingMethodAvailable = true
    }
    const selectedSubscription =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.subscriptions

    const isShowShippingMethod =
      month === 'showall' ? true : selectedSubscription?.length > 0

    const currencySymbol = this.props.currencySymbol || '$'
    let disableShippingMethod = false
    //let deliveryEstimate = properties?.deliveryEstimate || ''
    let description = shippingMethod?.description || ''
    /* deliveryEstimate = deliveryEstimate === '' ? description : deliveryEstimate
    let deliveryEstimateText = '- (' + deliveryEstimate + ' Business Days)'
    deliveryEstimateText =
      deliveryEstimate.toLowerCase() === 'none' ? '' : deliveryEstimateText */
    const getMonthlyPV =
      subscriptionContainer.subscriptionPreferenceResponse?.order?.monthlyPV ||
      0
    const shippingCost =
      getMonthlyPV >= 100 &&
      (method.toLowerCase() == 'economy' || name.toLowerCase() == 'economy')
        ? i18nTranslate('subscription.free', 'FREE')
        : `${currencySymbol}${cost}`
    const displayDescription =
      description?.toLowerCase() != 'none'
        ? `- (${description} business days)`
        : `- ${i18nTranslate('subscription.noItemsAdded', 'No Items Added')}`

    let shippingMethodLabel = name || method

    /**
     * @info CX16-10502
     * As part of above ticket , Shipping method is changed from admin properties and
     * hence changing that, this manual check for translation causes the text not be displayed in subscription dashboard
     * So commented below translation code as Translation of texts to be done after discussing and
     * Translation text will be received from backend once the changes are done
     */

    /*if ((name || method) === 'US Mail') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.USMail',
        'US Mail'
      )
    } else if ((name || method) === 'Standard (2-6 Business Day)') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.Standard',
        'Standard (2-6 Business Day)'
      )
    } else if ((name || method) === 'Express (1-3 Business Day)') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.Express',
        'Express (1-3 Business Day)'
      )
    } else if ((name || method) === 'One Day') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.OneDay',
        'One Day'
      )
    } else if ((name || method) === 'One Day Saturday') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.OneDaySaturday',
        'One Day Saturday'
      )
    } else if ((name || method) === 'PP(Canada Post)') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.canadaPost',
        'PP(Canada Post)'
      )
    } else if ((name || method) === 'UPS Ground') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.upsGround',
        'UPS Ground'
      )
    } else if ((name || method) === 'Pick Up - Mississauga Ontario') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.pickUpMississaugaOntario',
        'Pick Up - Mississauga Ontario'
      )
    } else if ((name || method) === 'Pick Up - Richmond British Columbia') {
      shippingMethodLabel = i18nTranslate(
        'subscription.shippingMethod.pickUpRichmondBritishColumbia',
        'Pick Up - Richmond British Columbia'
      )
    }*/
    if ((name || method) === '') {
      disableShippingMethod = true
    }
    if (!isShowShippingMethod) {
      disableShippingMethod = true
    }
    return (
      <>
        <div
          className={`p-0 border-0 ${isFromModal ? '' : 'shipping-section'}`}
          data-testid="qa-user-sub-shipping-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center shipping-title'}>
              <div className="shipping-title-inner d-flex justify-content-between">
                <div className="text-uppercase shipping-text heading-6">
                  {i18nTranslate(
                    'subscription.shippingMethod',
                    'Shipping Method'
                  )}
                </div>
                <div className="">
                  {this.disableShippingEdit == true ||
                  disableShippingMethod === true ||
                  !shippingMethodAvailable ? (
                    ''
                  ) : (
                    <Button
                      disabled={
                        this.disableShippingEdit ||
                        this.isShippingMethodCallInProgress
                      }
                      onClick={() => (this.isEditShippingMethod = true)}
                      className={'edit-button shadow-none p-0'}
                      data-testid="qa-user-sub-shipping-method-edit">
                      <Icons
                        name="CRUD"
                        icontype="edit"
                        width="20px"
                        customIcon={
                          i18nTranslate(
                            'subscriptions.editButtonText',
                            'Edit'
                          ) +
                          ' ' +
                          i18nTranslate(
                            'subscription.shippingMethod',
                            'Shipping Method'
                          ).toLowerCase()
                        }
                        alt={i18nTranslate(
                          'subscription.shippingMethodEditIcon',
                          'shipping method edit icon'
                        )}
                        ariaLabel={i18nTranslate(
                          'subscription.shippingMethodEditIcon',
                          'shipping method edit icon'
                        )}
                      />
                    </Button>
                  )}
                </div>
              </div>
            </Row>
          )}
          <Col className="p-0 text-dark paragraph-s">
            {isShowShippingMethod && (method || name) ? (
              <>
                {`${shippingMethodLabel} ${cost ? shippingCost : ''}`}
                {getMonthlyPV >= 100 &&
                  (method.toLowerCase() == 'economy' ||
                    name.toLowerCase() == 'economy') && (
                    <p className="m-0 mt-2 subscription-free-shipping">
                      {i18nTranslate(
                        'subscription.freeShipping',
                        `*You've qualified for free shipping because your order
                        exceeds 100PV`
                      )}
                    </p>
                  )}
              </>
            ) : (
              <>
                {i18nTranslate(
                  'subscription.shippingMethodDescription',
                  'No Shipment This Month'
                )}
              </>
            )}
          </Col>
        </div>
      </>
    )
  }

  updateSubscriptionAddress = async (
    data,
    isFromEditRadioOptionChange = false
  ) => {
    const updateSubscriptionResponse =
      await subscriptionContainer.updateSubscriptionsPreference(
        customerContainer.userId,
        data
      )
    if (subscriptionContainer.isSuccessResponse(updateSubscriptionResponse)) {
      await this.refetchGlobalPaymentOptionsAfterAddressSave()
      isFromEditRadioOptionChange
        ? toastState.setToastMessage(
            i18nTranslate(
              'address.updateShippingAddressSuccessSetSubsDefault',
              'Shipping address updated successfully and set as subscription default'
            ),
            true
          )
        : toastState.setToastMessage(
            i18nTranslate(
              'address.updateAddressSuccess',
              'Your address has been updated.'
            ),
            true
          )
    } else {
      const isServiceFailure =
        updateSubscriptionResponse?.isServiceFailure || false
      const errorCode =
        updateSubscriptionResponse?.responseCode ||
        updateSubscriptionResponse?.code ||
        ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : updateSubscriptionResponse?.message ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      return toastState.setToastMessage(errorMessage, false)
    }
  }

  refetchGlobalPaymentOptionsAfterAddressSave = async () => {
    if (!isGPSEnabled()) {
      return
    }
    await checkoutContainer.getGlobalPaymentOptions(true, true)
  }

  handleShippingSuggestionContinue = async (
    data,
    isFromModal,
    isRadioOptionChanged = false,
    validateAddressResponse = {},
    setDefaultShippingAddress = false
  ) => {
    this.isShippingAddressCallInProgress = true
    const { addresses } = subscriptionContainer.subscriptionPreferenceResponse
    this.newAddressToUpdate = data
    this.selectedShippingAddressId = data?.addressId || ''
    data.properties = {
      qasValidated: addressContainer.isQasValidated,
      selfValidated: addressContainer.isSelfValidated,
    }
    let response
    overlayState.toggleLoader()
    if (this.isEditShippingMethod) {
      response =
        await subscriptionContainer.getSubscriptionsPreferenceShippingMethods(
          customerContainer.userId,
          data
        )
    } else if (!isEmpty(addresses)) {
      response = await subscriptionContainer.getSubscriptionShippingAddress(
        customerContainer.userId,
        data
      )
    }
    const isSuccessValidate = addressContainer.isSuccessResponse(
      validateAddressResponse
    )

    if (
      (isEmpty(addresses) ||
        subscriptionContainer.isSuccessResponse(response)) &&
      isSuccessValidate &&
      !this.isAddressEditModal
    ) {
      // this.isEditShippingMethod = true
      this.subscriptionShippingAddressId =
        data.addressId || data.profileAddressId
      data.isDefault = this.editSubscriptionAddress.isDefault || true
      if (setDefaultShippingAddress || isRadioOptionChanged) {
        const isFromEditRadioOptionChange =
          isFromModal && isRadioOptionChanged ? true : false
        await this.updateSubscriptionAddress(data, isFromEditRadioOptionChange)
      }
      if (isRadioOptionChanged == true) {
        await addressContainer.updateProfileAddress(data, true)
      }
      this.isEditShippingAddress = false
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription())
      subscriptionContainer.isSuggestionSelected = false
    } else if (this.isAddressEditModal) {
      data.addressId = this.editSubscriptionAddress.addressId
      this.subscriptionShippingAddressId = data.addressId
      data.isDefault = this.editSubscriptionAddress.isDefault // to trigger the kafka message if the edit address is default in address book
      if (setDefaultShippingAddress || isRadioOptionChanged) {
        const isFromEditRadioOptionChange =
          isFromModal && isRadioOptionChanged ? true : false
        await this.updateSubscriptionAddress(data, isFromEditRadioOptionChange)
      }
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription())
      await addressContainer.updateProfileAddress(data, true)
      this.isAddressEditModal = false
      this.isEditShippingAddress = true
    } else {
      if (!isSuccessValidate) {
        if (validateAddressResponse.message) {
          toastState.setToastMessage(validateAddressResponse.message)
        }
      } else {
        const isServiceFailure = response?.isServiceFailure || false
        // const errorMessage = ''
        if (isServiceFailure) {
          toastState.setToastMessage(
            i18nTranslate(
              'subscription.somethingwentwrong',
              'Sorry, something went wrong. Please try again.'
            ),
            false
          )
        } else {
          if (response?.errors && isArray(response?.errors)) {
            if (response?.errors?.[0]) {
              toastState.setToastMessage(
                response?.errors?.[0]?.message ||
                  response?.errors?.[0]?.responseMessage
              )
            }
          } else {
            toastState.setToastMessage(
              response?.message || response?.responseMessage
            )
          }
        }
      }
    }
    overlayState.toggleLoader()
    this.isShippingAddressCallInProgress = false
  }
  handlePaymentSuggestionContinue = async (data, isFromModal) => {
    this.disablePaymentEdit = true
    this.isPaymentCallInProgress = true
    const { id } = data
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      {
        paymentId: id,
      }
    )
    this.isEditPayments = false
    this.enablePaymentModal = false
    if (subscriptionContainer.isSuccessResponse(response)) {
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription())
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.paymentMethod',
          'Your payment method has been updated.'
        ),
        true
      )
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    this.disablePaymentEdit = false
    this.isPaymentCallInProgress = false
  }
  isDisablePaymentModal = () => {
    this.enablePaymentModal = false
    this.isEditPayments = false
  }
  handleShippingMethodSuggestionContinue = async (data = {}, isFromModal) => {
    this.isShippingMethodCallInProgress = true
    this.disableShippingEdit = true
    const {
      shippingMethodId = '',
      name = '',
      description = '',
      expectedDaysForDelivery = '',
    } = data
    const shippingData = {
      deliveryPeriod: expectedDaysForDelivery,
      shippingInstruction: description,
      shippingType: data?.properties?.BOPIS
        ? SHIPPING_TYPE.STORE_PICKUP
        : SHIPPING_TYPE.PHYSICAL,
      shippingMethod: name,
      shippingId: shippingMethodId,
    }
    if (this.selectedShippingAddressId) {
      shippingData.addressId = this.selectedShippingAddressId
    } else if (this.newAddressToUpdate?.addressId) {
      const response = await addressContainer.addProfileAddress(
        this.newAddressToUpdate,
        false
      )
      if (customerContainer.isSuccessResponse(response)) {
        shippingData.addressId = response.addressId
      } else {
        this.isShippingMethodCallInProgress = false
        return false
      }
    }
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      shippingData
    )
    this.isEditShippingMethod = false
    if (subscriptionContainer.isSuccessResponse(response)) {
      addressContainer.getProfileAddress()
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription(true))
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.shippingMethodUpdated',
          'Shipping method updated Successfully'
        ),
        true
      )
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : response?.message ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    this.disableShippingEdit = false
    this.isShippingMethodCallInProgress = false
  }
  onMobileMonthDropdownClick = (value, showAll, month) => {
    subscriptionContainer.resetSubscriptionResponse(showAll, month)
    this.props.history.push({
      search: value,
    })
  }
  renderUpcomingFiveMonthsMobile = (startMonth, selectedMonth) => {
    if (startMonth <= 0) {
      return ''
    }
    let i = 1
    let queryParam = this.props.location?.queryParams?.month || ''
    let currentMonth = startMonth
    let newMonths = []
    let date = new Date()
    let year = date.getFullYear()
    let newYear = year
    for (i = 1; i <= 5; i++) {
      if (currentMonth > 12) {
        newYear = year + 1
      }
      let currentDate = new Date(newYear, currentMonth - 1, 1)
      let monthName = currentDate.toLocaleString('default', { month: 'short' })
      let month = currentDate.getMonth()

      newMonths.push(
        <Dropdown.Item
          className="subscription-month-dropdown-values"
          as="button"
          key={i}
          // value={}
          data-testid={`qa-user-sub-upcoming-delivery-month-${i}`}
          onClick={() =>
            this.onMobileMonthDropdownClick(
              `?month=${month + 1}`,
              false,
              month + 1
            )
          }>
          <span className="subscription-month-dropdown-link">{`${monthName} ${newYear}`}</span>
        </Dropdown.Item>
        // to unblock QA using Link tag,
        // checkAndRemoveLocaleFromPath to refined  based and queryparam
        // and change this to <linkwithlocale
        // @vetri @linkwithlocale @todo
      )
      currentMonth = startMonth + i
    }
    newMonths.push(
      <Dropdown.Item
        className="subscription-month-dropdown-values"
        as="button"
        key={i}
        data-testid={`qa-user-sub-upcoming-delivery-month`}
        onClick={() =>
          this.onMobileMonthDropdownClick(`?month=showall`, true, '')
        }>
        <span className="subscription-month-dropdown-link">{`SHOW ALL`}</span>
      </Dropdown.Item>
    )
    let selectedDate = new Date(newYear, selectedMonth - 1, 1)
    const selectedMonthName = selectedDate.toLocaleString('default', {
      month: 'short',
    })
    let currentSelectedMonth =
      startMonth > selectedMonth ? 12 + selectedMonth : selectedMonth

    // if (currentSelectedMonth > 12) {
    //   date.getFullYear() + 1
    // } else {
    //   date.getFullYear()
    // }
    return (
      <Dropdown className="subscription-month-dropdown w-100">
        <Dropdown.Toggle
          className="subscription-month-dropdown-toggle w-100 d-flex align-items-center rounded-0 shadow-none"
          variant=""
          data-testid="qa-subscription-month-dropdown">
          <span className="subscription-month-dropdown-text text-capitalize">
            {queryParam == 'showall'
              ? 'SHOW ALL'
              : `${selectedMonthName} ${newYear}`}
          </span>
          <span className="subscription-month-dropdown-arrow justify-content-center align-items-center d-flex">
            <Icons
              name="arrows"
              icontype="downarrow"
              ariaLabel={i18nTranslate('orders.toggle', 'Toggle search box')}
              alt={i18nTranslate('orders.toggle', 'Toggle search box')}
            />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu data-testid="qa-dropdown" className="rounded-0 w-100">
          {newMonths}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
  renderUpcomingFiveMonths = (startMonth, selectedMonth) => {
    if (startMonth <= 0) {
      return ''
    }
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    let currentMonth = startMonth
    let newMonths = []
    // let date = new Date()
    // let year = date.getFullYear()
    const currentSubscriptionMonth = getConvertedMonth(
      currentDateInMillis,
      timeZone
    )
    // let year = new Date(currentDateInMillis).toLocaleDateString([], {
    //   timeZone,
    //   year: 'numeric',
    // })
    const year = getConvertedYear(currentDateInMillis, timeZone)
    let newYear = year
    let queryParam = this.props.location?.queryParams?.month || ''
    //EC-8573 setting i<=1 so only current month and show all is displayed
    for (let i = 1; i <= 1; i++) {
      // if (currentMonth > 12) {
      //   newYear = parseInt(year) + 1
      //   currentMonth = currentMonth - 12
      // }
      // if Dec Month is already processed, we will be getting currentMonth as January
      // to update year, have checked the below condition
      if (currentSubscriptionMonth == 12 && currentMonth == 1) {
        newYear = parseInt(year) + 1
      }
      // let currentDate = new Date(newYear, currentMonth - 1, 1)
      // let monthName = currentDate.toLocaleString('default', { month: 'short' })
      // let month = currentDate.getMonth()
      let monthName = dateFormatDeps
        .matchMonthFromNumberToString(currentMonth)
        .substr(0, 3)
      let month = currentMonth
      let isMonthActive =
        selectedMonth == startMonth &&
        queryParam !== 'showall' &&
        queryParam !== 'pvassistant'
      newMonths.push(
        <Col
          className={`month-list ${isMonthActive ? 'selected' : ''}`}
          data-testid={`qa-user-sub-upcoming-delivery-month-${i}`}>
          <Link
            to={`?month=${month}${
              subscriptionContainer.allUsers &&
              this.props.selectedUser.buyerInfo
                ? '&id=' + this.props.selectedUser.buyerInfo.id
                : ''
            }`}
            onClick={() =>
              subscriptionContainer.resetSubscriptionResponse(
                false,
                month + 1,
                subscriptionContainer.allUsers
              )
            }>{`${monthName} ${newYear}`}</Link>
        </Col>
      )
      currentMonth = startMonth + i
    }
    newMonths.push(
      <Col
        className={`month-list ${queryParam === 'showall' ? 'selected' : ''}`}
        data-testid={`qa-user-sub-upcoming-delivery-month`}>
        <Link
          to={`?month=showall${
            subscriptionContainer.allUsers && this.props.selectedUser.buyerInfo
              ? '&id=' + this.props.selectedUser.buyerInfo.id
              : ''
          }`}
          onClick={() =>
            subscriptionContainer.resetSubscriptionResponse(
              true,
              '',
              subscriptionContainer.allUsers
            )
          }>{`show all`}</Link>
      </Col>
    )
    if (getAppConfig().shouldShowPvAssit) {
      newMonths.push(
        <Col
          className={`col-md-1 month-list ${
            queryParam === 'pvassistant' ? 'selected' : ''
          }`}
          data-testid={`qa-user-sub-upcoming-delivery-month`}>
          <Link
            to={`?month=pvassistant`}
            onClick={() =>
              subscriptionContainer.resetSubscriptionResponse(
                false,
                '',
                subscriptionContainer.allUsers
              )
            }>{`pv assistant`}</Link>
        </Col>
      )
    }
    return newMonths
  }
  renderIcon = isOpen => {
    return !isOpen ? (
      <Icons
        name="CRUD"
        icontype="plus"
        alt={i18nTranslate('icons.plus', 'plus icon', {
          nameSpace: 'ssr-resource',
        })}
        title={i18nTranslate('icons.plus', 'plus icon', {
          nameSpace: 'ssr-resource',
        })}
      />
    ) : (
      <Icons
        name="CRUD"
        icontype="minus"
        alt={i18nTranslate('icons.minus', 'minus icon', {
          nameSpace: 'ssr-resource',
        })}
        title={i18nTranslate('icons.minus', 'minus icon', {
          nameSpace: 'ssr-resource',
        })}
      />
    )
  }
  renderAccordion = (section = {}, index = 0) => {
    const { title = '', view = '' } = section
    if (view) {
      return (
        <AccordionBlock
          key={index}
          renderIcon={this.renderIcon}
          textClass="about-title d-flex"
          title={title}>
          {view}
        </AccordionBlock>
      )
    } else {
      return ''
    }
  }
  renderPaymentAndShipping = (addresses, payment, shipping) => {
    const paymentInfo = { ...payment }
    const paymentResp = customerContainer.paymentsForDashboard?.payments || []
    const orders = subscriptionContainer.subscriptionPreferenceResponse?.order
    const monthlyTotal = orders?.monthlyTotal || ''

    Array.isArray(paymentResp) &&
      paymentResp?.map((payment, index) => {
        if (
          parseInt(this.subscriptionPaymentId) == parseInt(payment?.id) &&
          payment?.type?.toLowerCase() == 'ach'
        ) {
          paymentInfo.properties = payment?.properties
        }
      })

    const view = (
      <div noGutters className="pb-2 w-100 shipping-methods">
        {this.renderPaymentMethod(paymentInfo, false, true)}
        {this.renderShippingAddress(addresses, false)}
        {this.renderShippingMethod(shipping, false)}
      </div>
    )
    return view
  }
  renderPaymentError = () => {
    return (
      <div className="warningErrorDiv">
        <Icons
          name="CRUD"
          icontype="closed-fill"
          className="subscription-payment-error-icon mt-2 ml-2"
          color="#BE1217"
        />
        <p className="m-0 mt-1 mb-1">
          {i18nTranslate(
            'subscription.paymentProcessingError',
            `Payment Processing Error: Please update information or add a new
            card.`
          )}
        </p>
      </div>
    )
  }

  renderPaymentCondition = () => {
    const totalActiveSubscriptionCount =
      cartContainer.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount || ''
    const defaultSelectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const month = this.props.location?.queryParams?.month || ''
    let selectedMonth = 0

    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const lastOrderProcessedMonth =
      new Date(lastOrderProcessingDate).getMonth() + 1
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    if (subscriptionContainer.selectedMonth != '') {
      selectedMonth = subscriptionContainer.selectedMonth
    } else {
      selectedMonth = defaultSelectedMonth
    }

    if (
      lastOrderProcessedMonth == selectedMonth &&
      (lastSubscriptionOrderStatus.toLowerCase() === 'payment_failed' ||
        lastSubscriptionOrderStatus.toLowerCase() === 'order_failed') &&
      totalActiveSubscriptionCount != 0 &&
      month !== 'showall'
    ) {
      return this.renderPaymentError()
    } else {
      return ''
    }
  }
  render() {
    const {
      addresses,
      payment,
      //shipping,
      // startMonth = 0,
      // isSubscriptionPaymentFailed = false,
      // currencySign,
      timeZone = 'US/Mountain',
    } = subscriptionContainer.subscriptionPreferenceResponse
    const shipping = subscriptionContainer.subscriptionShippingContent
    //EC-9115 Setting invalid selected month to current month
    // const getCurrentMonth = new Date().getMonth() + 1
    // const defaultSelectedMonth =
    //   subscriptionContainer.subscriptionPreferenceResponse?.
    //   selectedSubscriptions?.[0]?.selectedMonth || 0
    // const selectedSubscriptionsLength =
    //   subscriptionContainer.subscriptionPreferenceResponse?.selectedSubscriptions || []
    const { csrAdminCookie } = getAppConfig()
    //getCookie(csrAdminCookie) ? true : false
    const subscriptionProducts =
      subscriptionContainer.selectedSubscription || []
    const apiStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.apiStatus || ''
    const isServiceFailure =
      subscriptionContainer.subscriptionPreferenceResponse?.isServiceFailure ||
      false

    this.subscriptionPaymentId = payment?.id || ''
    this.subscriptionShippingAddressId = addresses?.id || ''
    this.subscriptionShipping = shipping?.id || ''
    const month = this.props.location?.queryParams?.month || ''
    let selectedMonth = 0
    /* const currentDate = 
      subscriptionContainer.subscriptionPreferenceResponse?.currentDate || ''
    ) */
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    //const dateNow = new Date(currentDateInMillis)
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    // const lastOrderProcessedMonth =
    //   new Date(lastOrderProcessingDate).getMonth() + 1
    const lastOrderProcessedMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )

    // const currentMonth = dateNow.getMonth() + 1
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)

    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    const selectedMonthNo =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || ''
    /*if (selectedMonthNo != '') {
      selectedMonth = selectedMonthNo
    } else {
      selectedMonth =
        lastSubscriptionOrderStatus.toLowerCase() == 'order_success' &&
        lastOrderProcessedMonth == currentMonth
          ? currentMonth + 1 > 12
            ? 1
            : currentMonth + 1
          : currentMonth
    }*/
    selectedMonth =
      lastSubscriptionOrderStatus.toLowerCase() == 'order_success' &&
      lastOrderProcessedMonth == currentMonth
        ? currentMonth + 1 > 12
          ? 1
          : currentMonth
        : currentMonth
    const customClassName =
      !application.isMobile && subscriptionContainer.isPreferenceAPIInProgress
        ? 'disabled'
        : ''

    const willShippingEdittingModalShow =
      (this.isEditPayments && !this.disablePaymentEdit) ||
      this.enablePaymentModal

    const paymentsForDashboard = customerContainer.paymentsForDashboard || {}
    return (
      <div className="SubscriptionSideBar">
        {application.isMobile && (
          <>
            {!subscriptionContainer.allUsers && addresses && payment && shipping
              ? this.renderPaymentAndShipping(addresses, payment, shipping)
              : addresses && shipping
                ? this.renderPaymentAndShipping(addresses, '', shipping)
                : ''}
            {!subscriptionContainer.allUsers && this.renderPaymentCondition()}
            {/* <Row
              noGutters
              className={`month-list-header text-uppercase pb-3 ${customClassName}`}>
              {selectedMonth &&
              subscriptionContainer.subscriptionPreferenceResponse
                .selectedSubscriptions
                ? this.renderUpcomingFiveMonths(selectedMonth, selectedMonth)
                : ''}
            </Row> */}
          </>
        )}
        {/* {apiStatus != 'failure' &&
        !isServiceFailure &&
        subscriptionProducts?.length > 0 &&
        application.isMobile &&
        month != 'showall'
          ? this.props.renderSubscriptionSavingsView()
          : ''} */}
        {this.props.renderScanCardInfo()}
        {!application.isMobile && (
          <>
            {/* <Row
              noGutters
              className={`month-list-header text-uppercase showAll_option ${customClassName}`}>
              {selectedMonth &&
              subscriptionContainer.subscriptionPreferenceResponse
                .selectedSubscriptions
                ? this.renderUpcomingFiveMonths(selectedMonth, selectedMonth)
                : ''}
            </Row> */}
            <Row noGutters>
              {!subscriptionContainer.allUsers
                ? this.renderPaymentAndShipping(addresses, payment, shipping)
                : !subscriptionContainer.allUsers && addresses && shipping
                  ? this.renderPaymentAndShipping(addresses, '', shipping)
                  : ''}
              {!subscriptionContainer.allUsers && this.renderPaymentCondition()}
            </Row>
          </>
        )}
        {!subscriptionContainer.allUsers &&
          this.isEditShippingAddress &&
          !this.disableShippingEdit && (
            <ShippingEditingModal
              toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
              renderTabs={true}
              recommendations={addressContainer.addressData}
              customModalTitle={`${i18nTranslate(
                'subscription.shippingTitle',
                'Shipping Address'
              )}`}
              customSaveButtonLabel={`${i18nTranslate(
                'subscription.continue',
                'Continue'
              )}`}
              selectedId={this.subscriptionShippingAddressId}
              isForShippingAddress={true}
              toggleSuggestionView={() => {
                this.selectedShippingAddressId = ''
                this.isEditShippingAddress = false
              }}
              renderShippingAddressComponent={this.renderShippingAddress}
              toggleOnSubmit={false}
              handleAddressContinue={this.handleShippingSuggestionContinue}
            />
          )}
        {!subscriptionContainer.allUsers && willShippingEdittingModalShow && (
          <ShippingEditingModal
            toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
            isSubscriptionPaymentEditButtonClicked={this.isEditPayments}
            renderTabs={true}
            // recommendations={customerContainer.paymentResponse}
            recommendations={paymentsForDashboard}
            totalPagesLength={this.totalPagesLength}
            //^ https://jira.skava.com/browse/YLUS-4471
            customModalTitle={`${i18nTranslate(
              'subscription.paymentTitle',
              'Payment Method'
            )}`}
            isForPaymentMethod={true}
            selectedId={this.subscriptionPaymentId}
            toggleSuggestionView={() => {
              this.isEditPayments = false
              this.enablePaymentModal = false
              subscriptionContainer.showEditPaymentFromModal = false
            }}
            renderShippingAddressComponent={(payment, isFromModal) => {
              if (
                !addressContainer.isShippingAddressSameAsBillingAddress &&
                addressContainer.isShippingAddressSameAsBillingAddress !=
                  undefined
              ) {
                return this.renderShippingAddress(payment, isFromModal)
              } else {
                const paymentProperties = payment?.properties || {}
                const paymentInfo = toJS(payment?.accountInfo || {})
                paymentInfo.properties = paymentProperties
                paymentInfo.type = paymentInfo.type || payment?.type
                paymentInfo.displayName = payment?.name
                return this.renderPaymentMethod(paymentInfo, isFromModal, false)
              }
            }}
            ref={this.shippingEditingModalRef}
            handleAddressContinue={this.handlePaymentSuggestionContinue}
          />
        )}
        {!subscriptionContainer.allUsers &&
          this.isEditShippingMethod &&
          !this.disableShippingEdit && (
            <ShippingEditingModal
              toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
              recommendations={
                subscriptionContainer.subscriptionShippingMethods
              }
              customModalTitle={`${i18nTranslate(
                'subscription.shippingMethod',
                'Shipping Method'
              )}`}
              selectedId={this.subscriptionShipping}
              isForShippingMethod={true}
              toggleSuggestionView={() => (this.isEditShippingMethod = false)}
              renderShippingAddressComponent={this.renderShippingMethod}
              handleAddressContinue={
                this.handleShippingMethodSuggestionContinue
              }
              selectedAddressId={this.subscriptionShippingAddressId}
            />
          )}
        {this.isAddressEditModal && (
          <ShippingEditingModal
            toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
            renderTabs={true}
            prefillData={this.editSubscriptionAddress}
            isExistingAddressEdit={true}
            toggleSuggestionView={() => {
              this.isAddressEditModal = false
            }}
            toggleOnSubmit={false}
            handleAddressContinue={this.handleShippingSuggestionContinue}
            renderShippingAddressComponent={this.renderShippingAddress}
          />
        )}
        {/* {this.showEditSubscriptionModal && (
          <EditSubscriptionPayment
            toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
            IDofCardToBeEdited={this.IDofCardToBeEdited}
            updateSubscription={this.props.updateSubscription || ''}
            closeModalCallback={() => {
              this.showEditSubscriptionModal = false
            }}
            billingAddressType="subscription"
          />
        )} */}
        {this.showEditPaymentModal && (
          <EditUpdatePaymentModal
            show={this.showEditPaymentModal}
            closeButton={this.toggleEditPaymentModal}
            billingAddressType="subscription"
            IDofCardToBeEdited={this.IDofCardToBeEdited}
            cardDetails={this.selectedCardData}
            isFromCheckout={false}
            isFromSubscription={true}
            closeModalCallback={() => {
              this.showEditPaymentModal = false
            }}
            handlePaymentSuggestionContinue={
              this.handlePaymentSuggestionContinue
            }
            selectedDefaultCardId={this.selectedDefaultCardId}
            isDisablePaymentModal={this.isDisablePaymentModal}
          />
        )}
        {this.showDeleteConfirmationModal && (
          <div>
            <Modal
              className={`visible modal-wrapper p-0`}
              show={this.showDeleteConfirmationModal}
              onHide={() => (this.showDeleteConfirmationModal = false)}
              centered
              animation={false}>
              <Modal.Header
                closeButton={this.toggleDeleteConfirmationModal}
                className={'border-bottom-0'}>
                <Modal.Title className="title-Payment-Modal">
                  {i18nTranslate(
                    'checkout.deletePayment',
                    'Delete payment method'
                  )}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.handleDeletePaymentMethod(this.selectedCardData)}
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    )
  }
}

export default SubscriptionShippingDetailsView
export { SubscriptionShippingDetailsView }
